module.exports = __webpack_public_path__ + "img/elevator_closing02.8f86b1d9.gif";